<template>
  <div class="atividades-programadasrealizadas ml-4 mr-4" >
      <b-form>          
          <b-row>
              <b-col cols=4>
                <label for="select-garagem">Garagem</label>
                <multiselect  v-model="garagem_value" :options="garagens" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=1>
                <label for="select-modalidade">Lote</label>  
                
                <multiselect v-model="modalidade_value"                                                         
                            :multiple="true"
                            @close="loadLinhas()"  
                            :allowEmpty="true"
                            :options="modalidades"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Lote" label="modalidade" track-by="modalidade" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Lote selecionado</span></template>                                        
                </multiselect> 
              </b-col>
            
              <b-col cols=3>
                  <label for="select-linha">Linha</label>
                  <multiselect v-model="linha_value"  :options="linhas" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecione a linha" label="linha" track-by="linha" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Linha selecionada</span></template>
                  </multiselect>
              </b-col>


             
              <b-col cols=3>
                   <div>                            
                        <label  for="datepicker-placeholder">Data escala de serviço</label>
                        <b-form-datepicker id="datepicker-placeholder"  v-model="data_operacao" placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>
              

                <b-col cols=1>
                  <br>
                  
                  <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadProgramadasRealizadas()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                  </b-button>                      
                </b-col>
              
          </b-row>



    </b-form>
    <hr>
    <b-table  small hover striped sticky-header="518px" :items="programadasrealizadas" :fields="fields">                            
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            carregando: false,
            atividade: {},
            atividades: [],  // [] lista
            garagem:{},
            garagens: [],   // [] lista

            modalidades:[],
            modalidade_value:[],
            linha_value:[],
            linhas: [], 
            garagem_value:[],           // [] lista            
            programadasrealizadas:[],// [] lista            
            data_operacao: '',

            
            fields: [
                

                { key: 'data', label: 'Data Operação', sortable: true, formatter: (value, key, programadasrealizadas) => {
                    return moment(programadasrealizadas.data).format('DD/MM/YYYY');} },

                { key: 'linha', label: 'Linha', sortable: true },
                { key: 'tabela', label: 'Tabela', sortable: true },
                { key: 'carro_pro', label: 'Carro Programado', sortable: true },                
                { key: 'carro_rea', label: 'Carro Realizado', sortable: true }, 
                { key: 're', label: 'Registro', sortable: true },
                { key: 'funcao', label: 'Função', sortable: true },
                { key: 'sentido', label: 'Sentido', sortable: true },
                { key: 'id_atividade', label: 'Codigo', sortable: true },
                { key: 'atividade', label: 'Atividade', sortable: true },
                { key: 'cheg_prog', label: 'Chegada Programada', sortable: true, formatter: (value, key, programadasrealizadas) => {
                    return moment(programadasrealizadas.cheg_prog).format('DD/MM/YYYY HH:mm');} },

                { key: 'cheg_real', label: 'Chegada Realizada', sortable: true, formatter: (value, key, programadasrealizadas) => {
                    return moment(programadasrealizadas.cheg_real).format('DD/MM/YYYY HH:mm');} },
                

               
                { key: 'minutos_diferenca', label: 'Minutos #', sortable: true, formatFn: (value, key, programadasrealizadas) => {
                    return moment(programadasrealizadas.minutos_diferenca).format('hh:mm:ss');} },        //:ms refere-se a miléssimo de segundos       
            


                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {
      
        loadGaragens() {
          const url = `${baseApiUrl}/trafego/garagem`
          axios.get(url).then(res => {            
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })            
          })
          
        },

        loadModalidades() {
          const url = `${baseApiUrl}/trafego/modalidade`          
          axios.get(url).then(res => {            
            this.modalidades = res.data.map(modalidade => {                                   
              return { id_modalidade: modalidade.id_modalidade, modalidade: modalidade.modalidade }
            })            
          })          
        },


         loadLinhas() {
            let corpo = {    
                "id_filial"    : `${[this.garagem_value.map(a => a.id_filial)]}`,            
                "id_modalidade": `${[this.modalidade_value.map(m => m.id_modalidade)]}`                  
            };

          const url = `${baseApiUrl}/trafego/linha`
          return axios.post(url,corpo).then(res => {
             this.linhas = res.data.map(linha => {
              return { ... linha}
            })
          })          
        },


        loadProgramadasRealizadas() {
          let corpo = {    
                "data_operacao": `${this.data_operacao}`,
                "id_filial"    : `${[this.garagem_value.map(f => f.id_filial)]}`,            
                "id_modalidade": `${[this.modalidade_value.map(m => m.id_modalidade)]}`,
                "linha": `${[this.linha_value.map(l => l.linha)]}`,
            };
          
          const url = `${baseApiUrl}/trafego/viagemprogramadasrealizadas`          
          axios.post(url,corpo).then(res => {
            this.carregando = false;
            this.programadasrealizadas = res.data.map(programadarealizada => {
                            return {data: programadarealizada.data, id_filial: programadarealizada.id_filial, linha: programadarealizada.linha,
                      tabela: programadarealizada.tabela, carro_pro: programadarealizada.carro_pro,carro_rea: programadarealizada.carro_rea, re: programadarealizada.re,
                      funcao: programadarealizada.funcao,sentido: programadarealizada.sentido, id_atividade: programadarealizada.id_atividade, 
                      atividade: programadarealizada.atividade, cheg_prog: programadarealizada.cheg_prog, cheg_real: programadarealizada.cheg_real,
                      minutos_diferenca: programadarealizada.minutos_diferenca
               }              
            })
          })
        }, 
    },

    mounted() {        
        this.loadGaragens()
        this.loadModalidades()
        this.loadLinhas()
        this.loadProgramadasRealizadas()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>
